import { styled } from '@mui/material'

import { theme } from 'styles/theme'

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '14px'
}))

/** A ênfase vem só do peso: Ink em 700 contra o texto do card em 400. */
export const Highlight = styled('span')(() => ({
  color: theme.palette.neutral[100],
  fontWeight: 700
}))

/**
 * Drawer recolhido: o card vira um botão de 36px com a mesma superfície do card
 * aberto (Mint Wash, borda e glifo Mint Deep), para os dois estados serem lidos como
 * o mesmo elemento em tamanhos diferentes.
 */
export const IconWrapper = styled('div')(() => ({
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
  margin: '0 auto',
  boxSizing: 'border-box',
  borderRadius: '10px',
  border: `1px solid ${theme.palette.primary[500]}`,
  backgroundColor: theme.palette.primary[600],
  transition: 'background-color 0.15s ease-out',
  '&:hover': {
    backgroundColor: theme.palette.primary[500]
  }
}))
